import FirebaseDependant from "./firebase.dependant.model";

export default class Model extends FirebaseDependant {
    _selfRef;
  
    get selfRef() {
      return this._selfRef;
    }
  }
